import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControlLabel,
  Switch,
  IconButton,
  Paper,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import CloseIcon from "@mui/icons-material/Close";

const UserDetailModal = ({ open, onClose }) => {
  const user = {
    name: "John Doe",
    email: "john.doe@example.com",
    products: [
      { id: 1, productName: "Product A", role: "Admin" },
      { id: 2, productName: "Product B", role: "User" },
      { id: 3, productName: "Product C", role: "Editor" },
    ],
  };
  const [accessStates, setAccessStates] = React.useState(
    user.products.map(() => true)
  );
  const [lockStates, setLockStates] = React.useState(
    user.products.map(() => true)
  );

  const handleAccessChange = (index) => {
    setAccessStates((prevAccessStates) =>
      prevAccessStates.map((access, i) => (i === index ? !access : access))
    );
  };

  const handleLockChange = (index) => {
    setLockStates((prevLockStates) =>
      prevLockStates.map((locked, i) => (i === index ? !locked : locked))
    );
  };

  if (!user || !user.products) return null;

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onClose();
        }
      }}
      fullWidth
      maxWidth="md"
      PaperProps={{
        style: {
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        style={{
          position: "relative",
          paddingRight: "48px",
        }}
      >
        User Details
        <IconButton
          edge="end"
          color="inherit"
          onClick={onClose}
          aria-label="close"
          style={{
            position: "absolute",
            right: 20,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        style={{
          overflowY: "auto",
        }}
      >
        <Box mb={2}>
          <Typography variant="h6">Name: {user.name}</Typography>
          <Typography variant="body1">Login ID: {user.email}</Typography>
        </Box>
        <TableContainer component={Paper} style={{ maxWidth: "100%" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>S.No</TableCell>
                <TableCell>Product Name</TableCell>
                <TableCell>Role</TableCell>
                <TableCell>Lock/Unlock</TableCell>
                <TableCell>Access/Denied</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {user.products.map((product, index) => (
                <TableRow key={product.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{product.productName}</TableCell>
                  <TableCell>{product.role}</TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleLockChange(index)}>
                      {lockStates[index] ? <LockOpenIcon /> : <LockIcon />}
                    </IconButton>
                  </TableCell>
                  <TableCell>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={accessStates[index]}
                          onChange={() => handleAccessChange(index)}
                          color="primary"
                        />
                      }
                      label={accessStates[index] ? "Granted" : "Denied"}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

export default UserDetailModal;
